export const ROLE = {
  developer: 13, //"Arendaja"
  manager: 21, //"Haldur"
  accountant: 27, //"Raamatupidaja"
  maintenance: 28, //"Hooldusmees"
  owner: 29, //"Korteriomanik"
  resident: 30, //"Elanik"
  tenat: 31, //"Üürnik"
  tenatCompany: 32, //"Rentnik(Ettevõte)"
  board: 35, //"Juhatuse liige"
  council: 39, //"Juhatuse liige / Majanõukogu liige"
  super_user: 45, //"Superuser"
  third_party: 47, //"Kolmas osapool"
  maintenance_manager: 53, //"Hooldusjuht TRT"
  authorized: 57, //"Volitatud Isik"
};

export const ROLE_TYPES = [
  { type: "kvatro", name: "employee" },
  { type: "resident", name: "resident_type" },
  { type: "board", name: "board" },
];

export const PRIVILEGES = {
  meeting: {
    addEdit: "EMEETING_ADDEDIT",
    view: "COOPERATIVE_EMEETING_VIEW",
    vote: "COOPERATIVE_EMEETING_VOTE",
    confirm: "COOPERATIVE_EMEETING_CONFIRM",
    protocol: "COOPERATIVE_EMEETING_PROTOCOL",
  },
  haldusnet: {
    user: "USER",
    view: "COOPERATIVE_VIEW",
    editCooperative: "COOPERATIVE_EDIT",
    viewCooperative: "COOPERATIVE_ALL_VIEW",
    editApartment: "COOPERATIVE_APARTMENT_EDIT",
    viewApartment: "COOPERATIVE_APARTMENT_VIEW",
    viewApartmentMeasurer: "COOPERATIVE_APARTMENT_MEASURER_VIEW",
    editApartmentMeasurer: "COOPERATIVE_APARTMENT_MEASURER_EDIT",
    buildingCooperative: "COOPERATIVE_BUILDING_EDIT",
    viewBuilding: "COOPERATIVE_BUILDING_EDIT",
    invoice: "COOPERATIVE_APARTMENT_SINGLE_INVOICE_VIEW",
    document: "COOPERATIVE_DOCUMENT_VIEW",
    documentEdit: "COOPERATIVE_DOCUMENT_EDIT",
    forumEdit: "COOPERATIVE_FORUM_EDIT",
    forumView: "COOPERATIVE_FORUM_VIEW",
    forumDelete: "COOPERATIVE_FORUM_DELETE",
    notification: "COOPERATIVE_NOTIFICATION_VIEW",
    notificationEdit: "COOPERATIVE_NOTIFICATION_EDIT",
    county: "INFORMATION_COUNTY",
    measurers: "COOPERATIVE_APARTMENT_SINGLE_MEASURER_VIEW",
    boardMeasurers: "COOPERATIVE_MEASURER_ENTRIES_VIEW",
    boardResidents: "COOPERATIVE_RESIDENT_VIEW",
    boardInvoice: "COOPERATIVE_INVOICE_VIEW",
    maintenance: "COOPERATIVE_TASK_MAINTENANCE_VIEW",
    gauge: "COOPERATIVE_MEASURER_VIEW",
    periods: "COOPERATIVE_BILLING_PERIOD_VIEW",
    measurerEdit: "COOPERATIVE_MEASURER_EDIT",
    entries: "COOPERATIVE_MEASURER_ENTRIES_VIEW",
    catalogues: "COOPERATIVE_DOCUMENT_TYPE_EDIT",
    editEntries: "COOPERATIVE_MEASURER_ENTRIES_EDIT",
    editClosedEntries: "COOPERATIVE_MEASURER_ENTRIES_EDIT_CLOSED",
    roles: "ROLE_ADMINISTRATION",
    privilege: "PRIVILEGE_ADMINISTRATION",
    kvatroNotification: "NOTIFICATION",
    kvatroNotificationEdit: "NOTIFICATION_EDIT",
    adminMenu: "ADMIN_MENU",
    users: "USER_ADMINISTRATION",
    labels: "LABELS_EDIT",
    taskWork: "TASK_WORK_ACCEPTING",
    userEdit: "USER_SELF_EDIT",
    apartmentSingleView: "COOPERATIVE_APARTMENT_SINGLE_VIEW",
    apartmentSingleEdit: "COOPERATIVE_APARTMENT_SINGLE_EDIT",
    apartmentOwner: "COOPERATIVE_APARTMENT_OWNER",
    informationService: "INFORMATION_SERVICE",
    apartmentMeasurerEdit: "COOPERATIVE_APARTMENT_SINGLE_MEASURER_EDIT",
    measurerDelete: "COOPERATIVE_MEASURER_DELETE",
    taskOrderingView: "TASK_ORDERING_VIEW",
    taskMaintenanceView: "TASK_MAINTENANCE_VIEW",
    cooperativePersonsView: "COOPERATIVE_PERSONS_VIEW",
    cooperativePersonsEdit: "COOPERATIVE_PERSONS_EDIT",
    cooperativeResidentEdit: "COOPERATIVE_RESIDENT_EDIT",
    cooperativeResidentInvoicePreferences:
      "COOPERATIVE_RESIDENT_INVOICE_PREFERENCES",
    cooperativeBuildingView: "COOPERATIVE_BUILDING_VIEW",
    coopertaiveMeasurerEntriesEditUnlimited:
      "COOPERATIVE_MEASURER_ENTRIES_EDIT_UNLIMITED",
  },
};

export const PERSON_TYPE = {
  kvatro: "kvatro",
  board: "board",
  resident: "resident",
};
export default {
  created() {
    this.ROLE = ROLE;
  },
};
